import React from 'react'
import TopBanner from './topBanner'
import BottomBanner from './bottomBanner'

const Scope1 = () => {
    return (
        <div className='home-scope1'>
            <TopBanner />
            <BottomBanner />
        </div>
    )
}

export default Scope1